/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isUndefined from 'lodash/isUndefined';

import MediumTypeLibrary from 'medium-type';

// TODO Hotfix neopravených bugů pomocí extends na knihovně.
/**
 * Media type.
 * Also known as MIME type or content type.
 *
 * Specification:
 * [RFC 2045](https://tools.ietf.org/html/rfc2045),
 * [RFC 2616](https://tools.ietf.org/html/rfc2616#section-14),
 * [RFC 3023](https://tools.ietf.org/html/rfc3023),
 * [RFC 6657](https://tools.ietf.org/html/rfc6657),
 * [RFC 6838](https://tools.ietf.org/html/rfc6838),
 * [RFC 6839](https://tools.ietf.org/html/rfc6839),
 * [RFC 7231](https://tools.ietf.org/html/rfc7231).
 *
 * Based on [medium-type](https://github.com/moll/js-medium-type) library.
 * @property {Object} parameters Parameters of the media type.
 * @property {string} subtype Subtype of the media type.
 * @property {string} suffix Suffix of the media type.
 * @property {string} type Top-level type of the media type.
 */
class MediumType extends MediumTypeLibrary {
  /**
   * Creates a new instance.
   * @param {Object|string} type Media type as a plain string or a map of properties.
   * @returns {MediumType} New media type instance.
   */
  constructor(type) {
    // TODO Oprava dosud neopraveného bugu s parsováním undefined.
    // - https://github.com/moll/js-medium-type/issues/4
    if (isUndefined(type)) {
      throw new SyntaxError(`Invalid Media Type: ${type}`);
    }
    const mediumType = super(type);
    // TODO Nemělo by být podporováno, ale plugin to neřeší.
    // - https://github.com/moll/js-medium-type/issues/1
    if (mediumType.type === '*' && mediumType.subtype !== '*') {
      throw new SyntaxError(`Invalid top-level type range: ${type}`);
    }
  }

  /**
   * Check for the strict equality with another media type.
   * @param {MediumType} mediumType Media type to check for equality.
   * @returns {boolean} True if both media types are equal in all of their parts.
   */
  equals(mediumType) {
    // TODO Přidáno porovnání striktní rovnosti typů (bez rozsahů).
    // - Mělo by být součástí knihovny.
    // - Naivní zpracování, bez důkladnějšího ošetření.
    // - https://github.com/moll/js-medium-type/issues/2
    return this.toString() === mediumType.toString();
  }
}

/**
 * Compare function to use with `Array#sort`.
 * This method is not documented in medium-type library,
 * but it [should work](https://github.com/moll/js-medium-type/issues/3).
 * @function
 * @name MediumType.comparator
 * @param {MediumType} aType First media type instance.
 * @param {MediumType} bType Second media type instance.
 * @returns {number} Result of a comparation: `0`, `1` or `-1`.
 */

/**
 * Matches a given media type pattern to the current media type.
 * Supports wildcards (`*`) for type and subtype.
 * @function
 * @name MediumType#match
 * @param {MediumType} type Media type instance to match to.
 * @returns {boolean} True if media type matches.
 */

/**
 * Stringifies a media type to a canonical string when passing it to `JSON.stringify`.
 * @function
 * @name MediumType#toJSON
 * @returns {string} Media type as JSON string.
 */

/**
 * Stringifies a media type to canonical form.
 * @function
 * @name MediumType#toString
 * @returns {string} Media type as a plain string.
 */

export default MediumType;
